import { render, staticRenderFns } from "./FarolEquipamentos.vue?vue&type=template&id=67a43fde&"
import script from "./FarolEquipamentos.vue?vue&type=script&lang=js&"
export * from "./FarolEquipamentos.vue?vue&type=script&lang=js&"
import style0 from "./FarolEquipamentos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports